import React, { useState } from 'react'
import { Wrap } from 'shared/components/Base/Base'
import { Box } from 'shared/components/Box/Box'
import { Button } from 'shared/components/Button/Button'
import { SimpleDialog } from 'shared/components/Dialog/SimpleDialog'
import { Text } from 'shared/components/Text/Text'
import { Handler } from 'shared/helpers/typeHelper'
import { deleteDrivingViolation, DrivingViolation } from 'shared/models/employment'
import { midGray } from 'shared/theme/colors'

import { User } from '../../../models/user'
import { useUserProvider } from '../../Context/UserContext'

interface DeleteViolationsProps {
  onSuccess: Handler
  onClose: Handler
  violations: DrivingViolation[]
  user: User
}

export function DeleteViolations({ onSuccess, onClose, violations, user }: DeleteViolationsProps) {
  const [isLoading, setIsLoading] = useState(false)
  const { showBanner } = useUserProvider()

  async function handleConfirm() {
    setIsLoading(true)
    try {
      const deletes = violations.map((violation) => deleteDrivingViolation(user.id, violation.id))
      await Promise.all(deletes)
      await onSuccess()
      setIsLoading(false)
    } catch (err: any) {
      showBanner('error', err)
      setIsLoading(false)
    }
  }
  return (
    <SimpleDialog onClose={onClose} isOpen hasBigPadding maxWidth="472px">
      <Wrap width="700px" maxWidth="100%">
        <Text variant="header2" align="left" mt={4}>
          Remove traffic violations?
        </Text>
        <Box mt={2} />
        <Text variant="paragraph1" mb={1} fontColor={midGray} align="left">
          You entries will be lost.
        </Text>

        <Box mt={8} />
        <Button margin="0 auto" variant="primary" size="large" onClick={handleConfirm} isLoading={isLoading}>
          Remove traffic violations
        </Button>
        <Box m={3} />
        <Button margin="0 auto" variant="text" onClick={onClose}>
          Cancel
        </Button>
      </Wrap>
    </SimpleDialog>
  )
}
